import {useCallback, useState} from 'react'
import _ from 'lodash'

export const useIncrementState = (def = 0) => {
	if (!_.isNumber(def)) throw new Error('incrementState needs a fucking number')
	const [state, setState] = useState(def)
	const incrementState = useCallback(() => setState(count => count + 1), [])
	return [state, incrementState, setState]
}
